import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { FuelService } from "@app/fuel/fuel.service";

@Injectable()
export class FuelRegionsResolver {
  constructor(private fuelService: FuelService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.fuelService.getRegions();
  }
}
